const fs = require("fs");
const async = require("async")
const moment = require('moment')
const path = require('path')
const _ = require('lodash')
const { templatesDirPath } = require('./templates/index')
const { sendReport } = require('./sendReportMail')

function base64Encode(file) {
    return fs.readFileSync(file, {encoding: 'base64'});
}


/*
function getBase64EncodedUrlImage(fileName) {
    const imagePath = path.join(global.appRoot, global.isProd ? "buildServer/img" : "src/img", fileName);
    const ext = path.extname(imagePath).slice(1);
    const bas64 = base64Encode(imagePath)
    return `data:image/${ext};base64,${bas64}`
}
 */

function getImageUrl(fileName) {
    const imagePath = path.join(global.appRoot, global.isProd ? "buildServer/img" : "src/img", fileName);
    // Use file:// protocol to avoid huge base64 strings in concatenated HTML,
    // which can crash puppeteer due to extreme string size.
    return `file://${imagePath}`;
}

const templateCache = {};
function getTemplate(language, callback) {
    const templatePath = path.join(templatesDirPath(language), 'taxReturnDocument.html');
    if (templateCache[templatePath]) return callback(null, templateCache[templatePath]);
    fs.readFile(templatePath, "utf8", (e, data) => {
        if (e) return callback(e);
        templateCache[templatePath] = data;
        callback(null, data);
    });
}

export const generate = function(users, refundsByUser, object, secretary, context, callback) {
    const outputName = `${moment(object.date).format("YYYY-MM-DD_HH-mm-ss")}_${object.exercise.code}_Attestation_de_remboursement.pdf`

    // Pre-calculate image URLs once for all users to save memory and CPU
    const logoUrl = getImageUrl('logo_mycsemanco.png');
    const signatureUrl = getImageUrl('signature_marie_gerard.png');

    const config = {
        margin: {
          top: '0px',
          bottom: '0px'
        },
        pdfName: outputName,
        outputInDB: true,
        displayHeaderFooter: false,
        cssSheet: ''
    }

    const configuration = {
        content: users.map(user => {
            const refund = refundsByUser[user.id] ? refundsByUser[user.id].reduce((acc, refundRequest) => acc + parseFloat(refundRequest.refund), 0) : 0
            return callback => {
                const language = user.language ? user.language.id : 'fr'
                getTemplate(language, (e, data) => {
                    if(e) return callback(e);
                    global.pdf.applyValuesToTemplate({
                        secretary: secretary.firstname + ' ' + secretary.lastname,
                        civility: context.tc(user.civility.id),
                        fullName: user.fullName,
                        exerciseYear: object.exercise.code,
                        period: `${moment(object.exercise.startDate).format('DD/MM/YYYY')} - ${moment(object.exercise.endDate).format('DD/MM/YYYY')}`,
                        documentId: `${object.exercise.code}-${user.registrationNumber}-${object.sequence}`,
                        date: moment().format('DD/MM/YYYY'),
                        refund: refund.toFixed(2),
                        logo: logoUrl,
                        signature: signatureUrl
                    }, data, (err, result) => {
                        if(object.archive || object.emailing) {
                            global.tmpManager.requestFolder((e, tmpFolder) => {
                                if(e) return callback(e);
                                global.pdf.renderAndExport(result, config, tmpFolder, (e, file) => {
                                    if(e) return callback(e)
                                    global.tmpManager.removeFolder(tmpFolder);
                                    //send emails and/or archive files
                                    async.parallel([
                                        callback => {
                                            if(object.archive) {
                                                global.app.R.CUser.collection.updateOne(
                                                    { _id: new global.ObjectID(user.id) },
                                                    {
                                                        $push: {
                                                            files: {
                                                                ...file,
                                                                user: _.pick(context.user, ['id', 'name']),
                                                                date: moment().format('YYYY-MM-DD HH:mm')
                                                            }
                                                        }
                                                    }
                                                ).then(() => callback()).catch(callback)
                                            } else callback(null)
                                        },
                                        callback => {
                                            if(object.emailing) {
                                                sendReport(user, object, file, context,(err) => {
                                                    if (!err) console.log('email sent...')
                                                    callback(err)
                                                })
                                            } else callback(null)
                                        }
                                        ],err => callback(err, result)
                                    )
                                })
                            })
                        } else callback(err, result)
                    })
                })
            }
        }),
        configuration: config
    }

    global.pdf.generatePdf(configuration, callback)
}
